"use client";

import { useHookstate } from "@hookstate/core";
import Grid from "@mui/material/Grid2";
import { useState } from "react";

import MDBox from "@/components/atoms/MDBox";
import { RecoverPasswordMessages } from "@/messages/recoverPassword/recover-password.messages";
import recoverPasswordEmailState from "@/states/recover-password-email";

import EmailSentStep from "./EmailSentStep";
import RecoverStep from "./RecoverStep";
import { RecoverPasswordSteps } from "./types";

type RecoverPasswordProps = {
  messages: RecoverPasswordMessages;
};
export default function RecoverPassword({ messages }: RecoverPasswordProps) {
  const predefinedEmail = "";

  const [recoverPasswordStep, setRecoverPasswordStep] = useState<RecoverPasswordSteps>("recover");

  const goToEmailSentStep = () => setRecoverPasswordStep("email_sent");

  return (
    <MDBox width="100%" height="var(--full-vh)" mx="auto">
      <Grid container justifyContent="center" alignItems="center" height="100%">
        <Grid
          size={{
            xs: 11,
            sm: 9,
            md: 5,
            lg: 4,
            xl: 3,
          }}
        >
          <MDBox>
            <Grid container justifyContent="center" width="100%">
              <Grid size={12}>
                {recoverPasswordStep === "recover" && (
                  <RecoverStep
                    messages={messages}
                    selectedEmail={predefinedEmail}
                    onSuccess={goToEmailSentStep}
                  />
                )}
                {recoverPasswordStep === "email_sent" && <EmailSentStep messages={messages} />}
              </Grid>
            </Grid>
          </MDBox>
        </Grid>
      </Grid>
    </MDBox>
  );
}
